export const CREATE_PASSWORD_FORM = 'createPassword';
